import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "pdfCompany",
  class: "p-4 w-full",
  style: {"color":"#fff","background-color":"#080718ff","border":"1px solid #171325ff"}
}
const _hoisted_2 = { class: "w-full flex" }
const _hoisted_3 = {
  class: "text-center w-full",
  style: {"font-size":"18px"}
}
const _hoisted_4 = { class: "w-full flex items-center" }
const _hoisted_5 = {
  class: "text-center flex-1",
  style: {"font-size":"16px"}
}
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = {
  class: "mt-2 w-full",
  style: {"border":"1px solid #465488"}
}
const _hoisted_11 = { class: "w-full flex items-center p-2" }
const _hoisted_12 = {
  style: {"width":"15%"},
  class: "px-2"
}
const _hoisted_13 = {
  style: {"width":"35%"},
  class: "px-2"
}
const _hoisted_14 = {
  style: {"width":"25%"},
  class: "px-2"
}
const _hoisted_15 = {
  style: {"width":"25%"},
  class: "px-2"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  style: {"width":"15%"},
  class: "px-2"
}
const _hoisted_18 = {
  style: {"width":"35%"},
  class: "px-2"
}
const _hoisted_19 = {
  style: {"width":"25%"},
  class: "px-2"
}
const _hoisted_20 = {
  style: {"width":"25%"},
  class: "px-2"
}
const _hoisted_21 = {
  key: 0,
  class: "mt-2 w-full"
}
const _hoisted_22 = ["id"]
const _hoisted_23 = {
  key: 1,
  class: "mt-2 w-full"
}
const _hoisted_24 = { class: "w-full" }
const _hoisted_25 = { class: "w-full text-center" }

import request from "../../../common/request";
import { ref, reactive, toRaw } from "vue";
import { v4 as uuidv4 } from "uuid";
import { getGroupName, getFactoryName } from "../../../common/tools";
import * as echarts from "echarts";
import { langList } from "../../../common/lang";
import htmlToPdf from "../../../common/htmlToPdf";
import { message } from "ant-design-vue";
import { getLanguage, getTranslation, getChineseFt } from "@/common/translate";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiagnosticReportDetails2',
  emits: ["cancel"],
  setup(__props, { expose: __expose, emit: __emit }) {

let reportInfo: any = ref({});
let langObj: any = ref({});
let language: any = ref("English");
const getLang = () => {
  language.value = localStorage.getItem("language") || "English";
  langObj.value = langList[language.value];
};
getLang();

let getDiagLang = (diagnosticNotes:any) => {
    try{
        let list1 = diagnosticNotes.split("；").filter((p:any) => p)
        let content = ''
        list1.map((d:any) => {
            let s1 = d.split("存在异常特征，判断为");
            let s1_1 = getTranslation(s1[0]);
            let s2 = s1[1].split('，');
            let s2_1 = getLanguage(s2[0]);

            let s3 = ''
            if(s2.length === 3) {
                s3 = '，' + s2[1] + '，' + s2[2]
            } else {
                s3 = '，' + s2[1]
            }
            if(language.value === 'English') {
                s3 = s3.replace("无设备故障，可持续运行", "there is no equipment failure and it can operate continuously")
                s3 = s3.replace("请关注设备分数变化情况", "please pay attention to the changes in the device scores")
                s3 = s3.replace("请关注设备状态与分数变化情况", "please pay attention to the status of the equipment and the changes in scores")
                s3 = s3.replace("请密切关注设备状态与分数变化情况，并结合现场情况适时安排检查", "please pay close attention to the status of the equipment and the changes in scores, and arrange inspections in a timely manner based on the on-site situation")
                s3 = s3.replace("请密切关注设备状态与分数变化情况，并结合现场情况适时安排检修", "please pay close attention to the status of the equipment and the changes in the score, and arrange maintenance in a timely manner in combination with the on-site situation")
                s3 = s3.replace("建议停机维护", "it is suggested to shut down for maintenance")
            }

            content = content + s1_1 + getLanguage("存在异常特征，判断为")+ s2_1 + s3
        })
        return content
    } catch(err:any) {
        return diagnosticNotes
    }
    
};

let gradeList = [
  { value: -1, label: "健康", color: "#61c08f", dec: "无需操作" },
  {
    value: 0,
    label: "可用",
    color: "#706a00ff",
    dec: "发现异常特征，按照巡查计划现场查看设备状态",
  },
  {
    value: 1,
    label: "警戒",
    color: "#cd5f3b",
    dec: "发现明显异常特征，现场检查设备状态，根据现场检查结果更新维护计划，适时维护设备",
  },
  {
    value: 2,
    label: "故障",
    color: "#921e37",
    dec: "设备故障严重，建议停机维修",
  },
];

const show = async (id: any) => {
  let config: any = {
    params: {
      id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get("/api/reports/info", config);

  if (result && result.data) {
    reportInfo.value = result.data;

    if (reportInfo.value.machines && reportInfo.value.machines.length) {
      reportInfo.value.factoryName = getFactoryName(
        reportInfo.value.machines[0].factoryId
      );
      reportInfo.value.groupName = getGroupName(
        reportInfo.value.machines[0].groupId
      );
      reportInfo.value.machineName = reportInfo.value.machines[0].machineName;

      reportInfo.value.expertReport?.diagnosisDetails &&
        reportInfo.value.expertReport.diagnosisDetails.map((d: any) => {
          d.faultCause = getLanguage(d.faultCause);
          d.faultCauses = d.faultCause
            ? d.faultCause.replace("\r\n", "\n").split("\n")
            : [];

          d.faultSuggest = getLanguage(d.faultSuggest);
          d.faultSuggests = d.faultSuggest
            ? d.faultSuggest.replace("\r\n", "\n").split("\n")
            : [];
        });

      setTimeout(() => {
        reportInfo.value.expertReport &&
          reportInfo.value.expertReport.diagnosisDetails.map(
            (d: any, index: any) => {
              d.trends &&
                d.trends.map((item: any, i: any) => {
                  initChart(item, "chart" + index + i);
                });
            }
          );
      }, 1000);
    }
  }
};

const initChart = (data: any, id: any) => {
  let dataAll: any = [];
  data.date.map((d: any, i: any) => {
    dataAll.push({ date: d, value: data.value[i] });
  });

  dataAll.sort(function (a: any, b: any) {
    if (a.date < b.date) return -1;
    if (a.date > b.date) return 1;
    return 0;
  });

  let dates = dataAll.map((p: any) => p.date);
  let values = dataAll.map((p: any) => p.value);
  data.date = dates;
  data.value = values;

  const ec = echarts as any;
  let doc = document.getElementById(id);
  if (!doc) return; // initChart放在timeout里面，可能会出现doc为null的情况
  let myChart = ec.init(doc);

  let markList: any[] = [];

  data.markLine?.data?.forEach((d: any) => {
    if (d.name == "开") {
      markList.push({
        name: langObj.value["开"],
        xAxis: d.xAxis,
        label: { show: true, color: "#fff", formatter: "{b}" },
        lineStyle: { color: "green" },
      });
    }
    if (d.name == "关") {
      markList.push({
        name: langObj.value["关"],
        xAxis: d.xAxis,
        label: { show: true, color: "#fff", formatter: "{b}" },
        lineStyle: { color: "rgb(173, 38, 64)" },
      });
    }
  });

  // console.log(markList)

  let titleT = ref("");
  if (!data.title) {
    data.title = "";
  }
  if (data.title.indexOf(":") != -1) {
    let titleArr = data.title.split(":");
    let title1 = langObj.value[titleArr[0]] || titleArr[0];
    let title2 = langObj.value[titleArr[1]] || titleArr[1];
    titleT.value = title1 + ":" + title2;
  } else if (data.title.indexOf("：") != -1) {
    let titleArr = data.title.split("：");
    let title1 = langObj.value[titleArr[0]] || titleArr[0];
    let title2 = langObj.value[titleArr[1]] || titleArr[1];
    titleT.value = title1 + ":" + title2;
  }

  const option = {
    title: {
      left: "center",
      textStyle: {
        fontSize: 12,
        color: "#fff",
      },
      text: titleT.value,
    },
    tooltip: {
      trigger: "axis",
    },
    grid: {
      top: "20%",
      left: "6%",
      right: "6%",
      bottom: "6%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: data.date,
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        type: "line",
        data: data.value,
        markLine: {
          data: markList,
          silent: true,
        },
      },
    ],
  };
  myChart.setOption(option);
};

const cancel = () => {
  emits("cancel", true);
};

const emits = __emit;

__expose({
  show,
});
const resultReport = ref<any>({});

// 下载pdf
let loadingDown = ref(false);
const handleDown = async () => {
  loadingDown.value = true; // 动画加载事件
  // 调用htmlToPdf工具函数
  let result = await htmlToPdf.getPdf("诊断报告", "a4");
  loadingDown.value = false;
  if (result) {
    message.success("下载成功");
  } else {
    message.warning("下载失败，请重试");
  }
};

// 转繁体
const translateFt = (ev: any) => {
  let content: any = ev;
  if (ev && language.value === "Chinese_ft") {
    content = getChineseFt(ev);
  }
  return content;
};

return (_ctx: any,_cache: any) => {
  const _component_close_outlined = _resolveComponent("close-outlined")!
  const _component_download_outlined = _resolveComponent("download-outlined")!
  const _component_a_image = _resolveComponent("a-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
      _createElementVNode("div", {
        class: "cursor-pointer",
        onClick: cancel
      }, [
        _createVNode(_component_close_outlined, {
          class: "clsIco",
          style: {"font-size":"20px"}
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getTranslation)(_unref(reportInfo).factoryName)) + " - " + _toDisplayString(_unref(getTranslation)(_unref(reportInfo).groupName)) + " - " + _toDisplayString(_unref(getTranslation)(_unref(reportInfo).machineName)) + " - " + _toDisplayString(_unref(langObj)["诊断报告"]), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(langObj)["报告时间"]) + ": " + _toDisplayString(_unref(reportInfo).date), 1),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleDown())),
          "nz-button": "",
          nzType: "text",
          class: "ml-2"
        }, [
          _createVNode(_component_download_outlined, { style: {"font-size":"18px"} })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, "1." + _toDisplayString(_unref(langObj)["设备信息"]), 1),
      _createElementVNode("div", null, _toDisplayString(_unref(langObj)["诊断设备"]) + ": " + _toDisplayString(_unref(getTranslation)(_unref(reportInfo).factoryName)) + " / " + _toDisplayString(_unref(getTranslation)(_unref(reportInfo).groupName)) + " / " + _toDisplayString(_unref(getTranslation)(_unref(reportInfo).machineName)) + " / " + _toDisplayString(_unref(langObj)["诊断报告"]), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, "2." + _toDisplayString(_unref(langObj)["设备健康状态"]), 1),
      (_unref(reportInfo).expertReport)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "mr-1",
              style: _normalizeStyle([{"width":"10px","height":"10px","border-radius":"50%"}, {
            background: _unref(gradeList).find(
              (p) => p.value === _unref(reportInfo).expertReport.grade
            )?.color,
          }])
            }, null, 4),
            _createElementVNode("span", null, _toDisplayString(_unref(langObj)[
            _unref(gradeList).find((p) => p.value === _unref(reportInfo).expertReport.grade)
              ?.label
          ]), 1),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "：", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(langObj)[
            _unref(gradeList).find((p) => p.value === _unref(reportInfo).expertReport.grade)
              ?.dec
          ]), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, "3." + _toDisplayString(_unref(langObj)["诊断结果"]), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(langObj)["故障模式"]), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(langObj)["诊断结论"]), 1),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(langObj)["故障原因"]), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(langObj)["建议及措施"]), 1)
        ]),
        (
            _unref(reportInfo).expertReport && _unref(reportInfo).expertReport.diagnosisDetails
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reportInfo).expertReport.diagnosisDetails, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"border-top":"1px solid #465488"},
                  key: index,
                  class: "w-full flex items-center p-2"
                }, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(langObj)[item.faultEvent] || item.faultEvent), 1),
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(getDiagLang)(item.diagnoseMessage)), 1),
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.faultCauses, (cause, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(_unref(getLanguage)(cause)), 1))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.faultSuggests, (suggest, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(_unref(getLanguage)(suggest)), 1))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(reportInfo).expertReport && _unref(reportInfo).expertReport.diagnosisDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reportInfo).expertReport.diagnosisDetails, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.trends, (t, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", {
                    id: 'chart' + index + i,
                    style: {"margin-top":"10px","width":"100%","height":"200px"}
                  }, null, 8, _hoisted_22)
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(reportInfo).pictures && _unref(reportInfo).pictures.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", null, "4." + _toDisplayString(_unref(langObj)["图片"]), 1),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reportInfo).pictures, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"width":"50%"},
                key: index
              }, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(item.remark), 1),
                _createVNode(_component_a_image, {
                  class: "w-full",
                  src: item.url,
                  alt: item.remark
                }, null, 8, ["src", "alt"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})